import { mergeProps } from "@base-ui/react/merge-props"
import { useRender } from "@base-ui/react/use-render"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "group/badge inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-[3px] border border-transparent px-2 py-0.5 text-[11px] font-bold whitespace-nowrap [&>svg]:pointer-events-none [&>svg]:size-3!",
  {
    variants: {
      variant: {
        default: "bg-[#E8E9EB] text-[#000A1E]",
        secondary: "bg-[#E8E9EB] text-[#000A1E]",
        success: "bg-[#D4EDDA] text-[#00823C]",
        warning: "bg-[#FFF3CD] text-[#856404]",
        destructive: "bg-[#F8D7DA] text-[#CC0000]",
        info: "bg-blue-50 text-[#0078C8]",
        outline: "border-[#CCCED2] text-[#000A1E] bg-transparent",
        ghost: "bg-transparent text-[rgba(0,10,30,0.75)]",
        link: "text-[#0078C8] underline-offset-4 hover:underline",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant = "default",
  render,
  ...props
}: useRender.ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return useRender({
    defaultTagName: "span",
    props: mergeProps<"span">(
      {
        className: cn(badgeVariants({ variant }), className),
      },
      props
    ),
    render,
    state: {
      slot: "badge",
      variant,
    },
  })
}

export { Badge, badgeVariants }
